import { render, staticRenderFns } from "./EditorGroupDetails.vue?vue&type=template&id=256eaf7a&"
import script from "./EditorGroupDetails.vue?vue&type=script&lang=js&"
export * from "./EditorGroupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports